import {
  Component,

  OnInit,
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {CompanyService} from "../services/company-service/company-service";
import {CategoryService} from "../services/category/category.service";
import {MatHeaderRow} from "../../../node_modules/@angular/material/typings/table/row";
import {TranslateService} from "ng2-translate";
import {OrderBagVM} from "../models/OrderBagVM.model";
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {AuthService} from "../services/auth/AuthService";
import {AuthGuard} from "../services/auth/AuthGuard";
import 'rxjs/add/operator/catch';
import { Title,Meta } from '@angular/platform-browser';
import {IAppConfig} from "../models/app-config.model";
import {AppConfig} from "../services/app.config";

/**
 * We're loading this component asynchronously
 * We are using some magic with es6-promise-loader that will wrap the module with a Promise
 * see https://github.com/gdi2290/es6-promise-loader for more info
 */

@Component({
  selector: 'orderbaglist',
  template: require('./orderbag-list.template.html'),
  styles: [require('./orderbag-list.component.css')]
})
export class OrderBagListComponent implements OnInit {

  public orderBagList:OrderBagVM[];
  public companyId = null;
  public setting: IAppConfig = AppConfig.settings;
  public justShowSlotStartTime : boolean = false;


  constructor(public router:Router,
              public authService:AuthService,
              public authGuard:AuthGuard,
              public companyService:CompanyService,
              public orderBagService:OrderBagService,
              public activatedRoute:ActivatedRoute,
              private pageTitle:Title,
              public translate:TranslateService) {
    // this.activatedRoute.queryParams.subscribe(params => {
    //   this.companyId = params['companyId'];
    //   console.log(this.companyId); // Print the parameter to the console.
    // });
    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
  }

  public ngOnInit() {
    this.fillOrderBagList();
  }

  fillOrderBagList() {

    let parent = this;
   this.companyService.getCompanyInfo().subscribe(function(company){
     // console.log(company);
     let companyId = null;
     if(parent.setting.ui.is_ssaa)
     {
        //nothing
       //show all reserve from all company
     }
     else
       companyId = company.id;



     //customSetting
     parent.justShowSlotStartTime = parent.companyService.getCompanyCustomSetting(company, 'justShowStartTime');


     parent.orderBagService.getActiveOrderBagList(companyId).subscribe((olist)=> {
       parent.orderBagList = olist;
       if(olist)
         parent.setPageTitle(olist.length)
       else
         parent.setPageTitle(0);

     })

    });
  }

  onItemExpanded(order) {
    this.orderBagService.getOrderBagDetailById(order.orderbagid).subscribe(detail=> {
      order.detail = detail;
      if (order.detail.imageAlbum)
        this.companyService.getAlbumImageList(order.detail.imageAlbum.id).subscribe((imageList)=> {
          if (imageList && imageList.length > 0)
            order.detail.coverImage = imageList[0];
        })
    })
  }
  onItemCollapsed(order){

  }
  gotoDetail(id) {
    this.router.navigateByUrl('/booked?id=' + id);
  }
  refreshReserveList()
  {
    this.fillOrderBagList();
  }
  login()
  {
    this.authGuard.openLoginDialog();
  }
  public setPageTitle(count:any)
  {
    let title='';
    if(count && count>0)
      title=" : "+count + "رزرو";

      this.pageTitle.setTitle('رزرو های من ' +title);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/+orderbag/orderbag-list.component.ts